import { render, staticRenderFns } from "./Pathao.vue?vue&type=template&id=a807dd3c&"
import script from "./Pathao.vue?vue&type=script&lang=js&"
export * from "./Pathao.vue?vue&type=script&lang=js&"
import style0 from "./Pathao.vue?vue&type=style&index=0&id=a807dd3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports